module.exports = __webpack_public_path__ + "static/media/OR 2.48c7529b.jpg";